import Vue from 'vue';
import Vuex from 'vuex';
import utils from '@/services/utils';
import school from './modules/school';
import learningCenter from './modules/learning-center/index';
import student from './modules/student/index';
import dualMeet from './modules/dual-meet/index';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    openId: utils.Cookie.get('openid'),
    account: null,
  },
  getters: {
    openId(state) {
      return state.openId;
    },
    isHeadMaster(state) {
      return state.account && state.account.user_type_id === '6';
    },
    isManager(state) {
      return state.account && state.account.user_type !== '6';
    },
  },
  modules: {
    school,
    learningCenter,
    student,
    dualMeet,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js